@if (status) {
  <span class="font-weight-bold" [ngClass]="{ 'text-success-light': SUCCESS_LIGHT.includes(status), 'text-in-progress': IN_PROGRESS.includes(status), 'text-primary': PRIMARY.includes(status), 'text-success': SUCCESS.includes(status), 'text-warning': WARNING.includes(status), 'text-danger': DANGER.includes(status), 'text-default': DEFAULT.includes(status)}">
    <span>{{ 'STATUS.' + (type != null ? type + '.' : '') + status | translate }} @if (hasTooltip) {
      <i class='fa' [ngClass]="{ 'fa-exclamation-circle': iconWithTooltip === 'exclamation' }" [ap-tooltip]="tooltipContent"></i>
    }</span>
  </span>
}
